(() => {
  function initCarousel(root) {
    const slides = Array.from(root.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-carousel-dot]'));
    const previous = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const status = root.querySelector('[data-carousel-status]');
    if (slides.length < 2 || !previous || !next) return;

    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let pendingIndex = null;
    let transitionTimer;
    let pointerStart = null;

    function updateControls(announce = true) {
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.setAttribute('aria-hidden', String(!active));
        slide.toggleAttribute('inert', !active);
      });
      dots.forEach((dot, i) => {
        if (i === current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (announce && status) status.textContent = `Banner ${current + 1} of ${slides.length}`;
    }

    function finishTransition(announce = true) {
      if (pendingIndex === null) return;
      window.clearTimeout(transitionTimer);
      slides[current].classList.remove('is-active', 'is-leaving');
      current = pendingIndex;
      pendingIndex = null;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      updateControls(announce);
    }

    function showSlide(index, announce = true) {
      if (pendingIndex !== null) finishTransition(false);
      const target = (index + slides.length) % slides.length;
      if (target === current) return;

      slides[current].classList.add('is-leaving');
      slides[current].setAttribute('aria-hidden', 'true');
      slides[current].setAttribute('inert', '');
      pendingIndex = target;
      transitionTimer = window.setTimeout(() => finishTransition(announce), 500);
    }

    previous.addEventListener('click', () => showSlide((pendingIndex ?? current) - 1));
    next.addEventListener('click', () => showSlide((pendingIndex ?? current) + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => showSlide(index)));
    root.addEventListener('pointerdown', (event) => {
      pointerStart = { x: event.clientX, target: event.target };
    }, { passive: true });
    root.addEventListener('pointerup', (event) => {
      if (!pointerStart) return;
      const distance = event.clientX - pointerStart.x;
      const startedInAgeScroller = pointerStart.target instanceof Element && pointerStart.target.closest('.home-platform-carousel__age-list');
      pointerStart = null;
      if (startedInAgeScroller || Math.abs(distance) < 45) return;
      showSlide((pendingIndex ?? current) + (distance < 0 ? 1 : -1));
    }, { passive: true });
    root.addEventListener('pointercancel', () => { pointerStart = null; }, { passive: true });

    updateControls(false);
  }

  function boot() {
    document.querySelectorAll('[data-home-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
